// import React, { useState } from "react";
// import createInstance from "../../../api/axiosinstance";
// import Toast from "../../../utils/toast";
// import Loader from "../../Loader";
// import {
//   Modal,
//   Box,
//   Typography,
//   TextField,
//   Button,
//   Select,
//   MenuItem,
//   FormControl,
//   InputLabel,
//   Card,
//   CardContent,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Paper,
//   IconButton,
// } from "@mui/material";
// import { useSelector } from "react-redux";
// import CloseIcon from "@mui/icons-material/Close";
// import ClearIcon from "@mui/icons-material/Clear";
// import SendIcon from "@mui/icons-material/Send";
// import { useThemeMode } from "../../Themes/ThemeContextTemp.js";


// const TP_FeedbackForm = ({ isOpen, onClose, interviewId }) => {
//   const [formData, setFormData] = useState({
//     technicalKnowledge: { notes: "", score: "", comments: "" },
//     handsOnSkills: { notes: "", score: "", comments: "" },
//     analyticalThinking: { notes: "", score: "", comments: "" },
//     communicationSkills: { notes: "", score: "", comments: "" },
//     culturalFit: { notes: "", score: "", comments: "" },
//     additionalObservations: "",
//     decision: "",
//     nextRoundRecommendation: "",
//     remarksForHR: "",
//   });
    
  
//   const { user } = useSelector((state) => state.auth);
//   const tpInterviewerId = user?.panelistId;


//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const aiDishaApi = createInstance("DISHA");
//   const { COLORS } = useThemeMode();

//   // Handle input change
//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     if (name.includes(".")) {
//       const [section, field] = name.split(".");
//       setFormData((prev) => ({
//         ...prev,
//         [section]: { ...prev[section], [field]: value },
//       }));
//     } else {
//       setFormData((prev) => ({ ...prev, [name]: value }));
//     }
//   };

//   // Calculate average rating
//   const calculateAverageRating = () => {
//     const scores = [
//       parseInt(formData.technicalKnowledge.score) || 0,
//       parseInt(formData.handsOnSkills.score) || 0,
//       parseInt(formData.analyticalThinking.score) || 0,
//       parseInt(formData.communicationSkills.score) || 0,
//       parseInt(formData.culturalFit.score) || 0,
//     ];
//     const valid = scores.filter((s) => s > 0);
//     if (!valid.length) return 0;
//     return Math.round(valid.reduce((a, b) => a + b, 0) / valid.length);
//   };

//   // Submit feedback (corrected endpoint)
//   const handleFormSubmit = async (e) => {
//     e.preventDefault();

//     const avgRating = calculateAverageRating();
//     if (avgRating === 0) {
//       Toast.error("Please provide ratings for at least one category");
//       return;
//     }
//     if (!formData.decision) {
//       Toast.error("Please select a decision");
//       return;
//     }

//     const payload = {
//       Detail_schema: {
//         Technical_knowledge_detail: formData.technicalKnowledge.notes || "N/A",
//         Hands_on_skills_detail: formData.handsOnSkills.notes || "N/A",
//         Problem_solving_detail: formData.analyticalThinking.notes || "N/A",
//         Communication_skills_detail:
//           formData.communicationSkills.notes || "N/A",
//         Culture_fit_detail: formData.culturalFit.notes || "N/A",
//       },
//       scorecard: {
//         Technical_knowledge: [
//           {
//             rating: parseInt(formData.technicalKnowledge.score) || 0,
//             comment: formData.technicalKnowledge.comments || "",
//           },
//         ],
//         Hands_on_skills: [
//           {
//             rating: parseInt(formData.handsOnSkills.score) || 0,
//             comment: formData.handsOnSkills.comments || "",
//           },
//         ],
//         Problem_solving: [
//           {
//             rating: parseInt(formData.analyticalThinking.score) || 0,
//             comment: formData.analyticalThinking.comments || "",
//           },
//         ],
//         Communication_skills: [
//           {
//             rating: parseInt(formData.communicationSkills.score) || 0,
//             comment: formData.communicationSkills.comments || "",
//           },
//         ],
//         Culture_fit: [
//           {
//             rating: parseInt(formData.culturalFit.score) || 0,
//             comment: formData.culturalFit.comments || "",
//           },
//         ],
//       },
//     };

//     try {
//       setIsSubmitting(true);

//       const response = await aiDishaApi.put(
//         `/update_third_party_interview_status_and_feedback?interview_id=${interviewId}&interviewer_id=${tpInterviewerId}&decision=${encodeURIComponent(
//           formData.decision
//         )}&next_round_recommendation=${encodeURIComponent(
//           formData.nextRoundRecommendation
//         )}&remarks=${encodeURIComponent(formData.remarksForHR)}`,
//         payload
//       );

//       if (response?.data?.message) {
//         Toast.success(response.data.message);
//       } else {
//         Toast.success("Feedback submitted successfully!");
//       }

//       clearForm();
//       onClose();
//       console.log("Feedback submitted:", response.data);
//     } catch (error) {
//       console.error("Error submitting TP feedback:", error);
//       if (error) {
//         Toast.error(
//           error?.response?.data?.detail || "Failed to submit feedback"
//         );
//       } else {
//         Toast.error("Failed to submit feedback. Try again later.");
//       }
//     } finally {
//       setIsSubmitting(false);
//     }
//   };

//   // Reset form
//   const clearForm = () => {
//     setFormData({
//       technicalKnowledge: { notes: "", score: "", comments: "" },
//       handsOnSkills: { notes: "", score: "", comments: "" },
//       analyticalThinking: { notes: "", score: "", comments: "" },
//       communicationSkills: { notes: "", score: "", comments: "" },
//       culturalFit: { notes: "", score: "", comments: "" },
//       additionalObservations: "",
//       decision: "",
//       nextRoundRecommendation: "",
//       remarksForHR: "",
//     });
//   };

//   const modalStyle = {
//     position: "absolute",
//     top: "50%",
//     left: "50%",
//     transform: "translate(-50%, -50%)",
//     width: "80%",
//     maxWidth: 1000,
//     maxHeight: "90vh",
//     overflow: "auto",
//     bgcolor: "background.paper",
//     boxShadow: 24,
//     borderRadius: 1,
//   };

//   return (
//     <Modal
//       open={isOpen}
//       onClose={onClose}
//       aria-labelledby="tp-interview-feedback"
//       aria-describedby="tp-interview-feedback-form"
//     >
//       <Box sx={modalStyle}>
//         {/* Header */}
//         <Box
//           sx={{
//             display: "flex",
//             justifyContent: "space-between",
//             alignItems: "center",
//             p: 2,
//             background: COLORS.accent,
//             color: COLORS.text,
//           }}
//         >
//           <Typography variant="h6">TP Interview Feedback Form</Typography>
//           <IconButton sx={{ color: COLORS.text }} onClick={onClose}>
//             <CloseIcon />
//           </IconButton>
//         </Box>

//         {/* Form Body */}
//         <Box component="form" onSubmit={handleFormSubmit} sx={{ p: 3 }}>
//           {/* Detailed Feedback */}
//           <Card sx={{ mb: 3 }}>
//             <CardContent>
//               <Typography variant="h6" gutterBottom>
//                 Feedback Summary
//               </Typography>
//               {[
//                 { id: "technicalKnowledge", label: "Technical Knowledge" },
//                 { id: "handsOnSkills", label: "Hands-on Skills" },
//                 { id: "analyticalThinking", label: "Problem Solving" },
//                 { id: "communicationSkills", label: "Communication Skills" },
//                 { id: "culturalFit", label: "Behavioral / Cultural Fit" },
//               ].map((item) => (
//                 <TextField
//                   key={item.id}
//                   fullWidth
//                   name={`${item.id}.notes`}
//                   label={item.label}
//                   multiline
//                   rows={3}
//                   value={formData[item.id].notes}
//                   onChange={handleInputChange}
//                   margin="normal"
//                 />
//               ))}

//               <TextField
//                 fullWidth
//                 name="additionalObservations"
//                 label="Additional Observations"
//                 multiline
//                 rows={3}
//                 value={formData.additionalObservations}
//                 onChange={handleInputChange}
//                 margin="normal"
//               />
//             </CardContent>
//           </Card>

//           {/* Scorecard */}
//           <Card sx={{ mb: 3 }}>
//             <CardContent>
//               <Typography variant="h6" gutterBottom>
//                 Scorecard (1 - Poor, 5 - Excellent)
//               </Typography>
//               <TableContainer component={Paper}>
//                 <Table>
//                   <TableHead>
//                     <TableRow sx={{ bgcolor: "grey.100" }}>
//                       <TableCell>Category</TableCell>
//                       <TableCell align="center">Score</TableCell>
//                       <TableCell>Comments</TableCell>
//                     </TableRow>
//                   </TableHead>
//                   <TableBody>
//                     {[
//                       {
//                         id: "technicalKnowledge",
//                         label: "Technical Knowledge",
//                       },
//                       { id: "handsOnSkills", label: "Hands-on Skills" },
//                       { id: "analyticalThinking", label: "Problem Solving" },
//                       {
//                         id: "communicationSkills",
//                         label: "Communication Skills",
//                       },
//                       { id: "culturalFit", label: "Cultural Fit" },
//                     ].map((item) => (
//                       <TableRow key={item.id}>
//                         <TableCell>{item.label}</TableCell>
//                         <TableCell align="center">
//                           <TextField
//                             type="number"
//                             name={`${item.id}.score`}
//                             value={formData[item.id].score}
//                             onChange={handleInputChange}
//                             inputProps={{ min: 1, max: 5 }}
//                             size="small"
//                             sx={{ width: 80 }}
//                           />
//                         </TableCell>
//                         <TableCell>
//                           <TextField
//                             fullWidth
//                             name={`${item.id}.comments`}
//                             value={formData[item.id].comments}
//                             onChange={handleInputChange}
//                             size="small"
//                           />
//                         </TableCell>
//                       </TableRow>
//                     ))}
//                   </TableBody>
//                 </Table>
//               </TableContainer>
//             </CardContent>
//           </Card>

//           {/* Final Decision */}
//           <Card sx={{ mb: 3 }}>
//             <CardContent>
//               <Typography variant="h6" gutterBottom>
//                 Final Recommendation
//               </Typography>
//               <FormControl fullWidth margin="normal">
//                 <InputLabel id="decision-label">Decision</InputLabel>
//                 <Select
//                   labelId="decision-label"
//                   name="decision"
//                   value={formData.decision}
//                   onChange={handleInputChange}
//                   sx={{ color: "black" }}
//                 >
//                   <MenuItem value="" sx={{ color: "black" }}>
//                     Select Decision
//                   </MenuItem>
//                   <MenuItem value="Strong Hire" sx={{ color: "black" }}>
//                     Strong Hire
//                   </MenuItem>
//                   <MenuItem value="Hire" sx={{ color: "black" }}>
//                     Hire
//                   </MenuItem>
//                   <MenuItem value="Borderline" sx={{ color: "black" }}>
//                     Borderline
//                   </MenuItem>
//                   <MenuItem value="No Hire" sx={{ color: "black" }}>
//                     No Hire
//                   </MenuItem>
//                   <MenuItem value="Keep in Pipeline" sx={{ color: "black" }}>
//                     Keep in Pipeline
//                   </MenuItem>
//                 </Select>
//               </FormControl>

//               <TextField
//                 fullWidth
//                 name="nextRoundRecommendation"
//                 label="Next Round Recommendation"
//                 value={formData.nextRoundRecommendation}
//                 onChange={handleInputChange}
//                 margin="normal"
//               />

//               <TextField
//                 fullWidth
//                 name="remarksForHR"
//                 label="Remarks for HR / Next Interviewer"
//                 multiline
//                 rows={3}
//                 value={formData.remarksForHR}
//                 onChange={handleInputChange}
//                 margin="normal"
//               />
//             </CardContent>
//           </Card>

//           {isSubmitting && <Loader />}

//           <Box
//             sx={{ display: "flex", justifyContent: "center", gap: 2, mb: 2 }}
//           >
//             <Button
//               variant="outlined"
//               color="secondary"
//               startIcon={<ClearIcon />}
//               onClick={clearForm}
//               disabled={isSubmitting}
//             >
//               Clear
//             </Button>
//             <Button
//               type="submit"
//               variant="contained"
//               endIcon={<SendIcon />}
//               disabled={isSubmitting}
//               sx={{
//                 color: COLORS.text,
//                 background: COLORS.accent,
//                 "&:hover": { background: COLORS.hoverBg },
//               }}
//             >
//               Submit Feedback
//             </Button>
//           </Box>
//         </Box>
//       </Box>
//     </Modal>
//   );
// };

// export default TP_FeedbackForm;















































































import React, { useState } from "react";
import createInstance from "../../../api/axiosinstance";
import Toast from "../../../utils/toast";
import Loader from "../../Loader";
import {
  Modal,
  Box,
  Typography,
  TextField,
  Button,
  Select,
  MenuItem,
  FormControl,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
} from "@mui/material";
import { useSelector } from "react-redux";
import CloseIcon from "@mui/icons-material/Close";
import ClearIcon from "@mui/icons-material/Clear";
import SendIcon from "@mui/icons-material/Send";
import EmojiObjectsOutlinedIcon from "@mui/icons-material/EmojiObjectsOutlined";
import { useThemeMode } from "../../Themes/ThemeContextTemp.js";

const TP_FeedbackForm = ({ isOpen, onClose, interviewId }) => {
  const [formData, setFormData] = useState({
    technicalKnowledge: { notes: "", score: "", comments: "" },
    handsOnSkills: { notes: "", score: "", comments: "" },
    analyticalThinking: { notes: "", score: "", comments: "" },
    communicationSkills: { notes: "", score: "", comments: "" },
    culturalFit: { notes: "", score: "", comments: "" },
    additionalObservations: "",
    decision: "",
    nextRoundRecommendation: "",
    remarksForHR: "",
  });

  const { user } = useSelector((state) => state.auth);
  const tpInterviewerId = user?.panelistId;

  const [isSubmitting, setIsSubmitting] = useState(false);
  const aiDishaApi = createInstance("DISHA");
  const { COLORS } = useThemeMode();

  // Handle input change
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name.includes(".")) {
      const [section, field] = name.split(".");
      setFormData((prev) => ({
        ...prev,
        [section]: { ...prev[section], [field]: value },
      }));
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  // Calculate average rating
  const calculateAverageRating = () => {
    const scores = [
      parseInt(formData.technicalKnowledge.score) || 0,
      parseInt(formData.handsOnSkills.score) || 0,
      parseInt(formData.analyticalThinking.score) || 0,
      parseInt(formData.communicationSkills.score) || 0,
      parseInt(formData.culturalFit.score) || 0,
    ];
    const valid = scores.filter((s) => s > 0);
    if (!valid.length) return 0;
    return Math.round(valid.reduce((a, b) => a + b, 0) / valid.length);
  };

  // Submit feedback
  const handleFormSubmit = async (e) => {
    e.preventDefault();

    const avgRating = calculateAverageRating();
    if (avgRating === 0) {
      Toast.error("Please provide ratings for at least one category");
      return;
    }
    if (!formData.decision) {
      Toast.error("Please select a decision");
      return;
    }

    const payload = {
      Detail_schema: {
        Technical_knowledge_detail: formData.technicalKnowledge.notes || "N/A",
        Hands_on_skills_detail: formData.handsOnSkills.notes || "N/A",
        Problem_solving_detail: formData.analyticalThinking.notes || "N/A",
        Communication_skills_detail: formData.communicationSkills.notes || "N/A",
        Culture_fit_detail: formData.culturalFit.notes || "N/A",
      },
      scorecard: {
        Technical_knowledge: [
          {
            rating: parseInt(formData.technicalKnowledge.score) || 0,
            comment: formData.technicalKnowledge.comments || "",
          },
        ],
        Hands_on_skills: [
          {
            rating: parseInt(formData.handsOnSkills.score) || 0,
            comment: formData.handsOnSkills.comments || "",
          },
        ],
        Problem_solving: [
          {
            rating: parseInt(formData.analyticalThinking.score) || 0,
            comment: formData.analyticalThinking.comments || "",
          },
        ],
        Communication_skills: [
          {
            rating: parseInt(formData.communicationSkills.score) || 0,
            comment: formData.communicationSkills.comments || "",
          },
        ],
        Culture_fit: [
          {
            rating: parseInt(formData.culturalFit.score) || 0,
            comment: formData.culturalFit.comments || "",
          },
        ],
      },
    };

    try {
      setIsSubmitting(true);

      const response = await aiDishaApi.put(
        `/update_third_party_interview_status_and_feedback?interview_id=${interviewId}&interviewer_id=${tpInterviewerId}&decision=${encodeURIComponent(
          formData.decision
        )}&next_round_recommendation=${encodeURIComponent(
          formData.nextRoundRecommendation
        )}&remarks=${encodeURIComponent(formData.remarksForHR)}`,
        payload
      );

      if (response?.data?.message) {
        Toast.success(response.data.message);
      } else {
        Toast.success("Feedback submitted successfully!");
      }

      clearForm();
      onClose();
    } catch (error) {
      console.error("Error submitting TP feedback:", error);
      Toast.error(error?.response?.data?.detail || "Failed to submit feedback");
    } finally {
      setIsSubmitting(false);
    }
  };

  // Reset form
  const clearForm = () => {
    setFormData({
      technicalKnowledge: { notes: "", score: "", comments: "" },
      handsOnSkills: { notes: "", score: "", comments: "" },
      analyticalThinking: { notes: "", score: "", comments: "" },
      communicationSkills: { notes: "", score: "", comments: "" },
      culturalFit: { notes: "", score: "", comments: "" },
      additionalObservations: "",
      decision: "",
      nextRoundRecommendation: "",
      remarksForHR: "",
    });
  };

  // Shared sx helpers
  const sectionHeaderSx = {
    fontFamily: "Poppins",
    fontSize: "14px",
    fontWeight: 600,
    color: COLORS.text,
    textTransform: "uppercase",
    letterSpacing: "0.05em",
    display: "flex",
    alignItems: "center",
    gap: "8px",
    mb: "16px",
  };

  const cardSx = {
    background: COLORS.primary,
    border: COLORS.border,
    borderRadius: "12px",
    mb: 2,
  };

  const textFieldSx = {
    "& .MuiOutlinedInput-root": {
      fontFamily: "Poppins",
      color: COLORS.text,
      "& fieldset": {
        borderColor: COLORS.border?.replace("1px solid ", "") || "#e5e7eb",
      },
      "&:hover fieldset": {
        borderColor: COLORS.border?.replace("1px solid ", "") || "#d1d5db",
      },
    },
    "& .MuiInputBase-input::placeholder": {
      color: `${COLORS.text}80`,
      opacity: 1,
    },
    "& .MuiInputLabel-root": {
      fontFamily: "Poppins",
      color: `${COLORS.text}80`,
      fontSize: "13px",
    },
  };

  return (
    <Modal
      open={isOpen}
      onClose={onClose}
      aria-labelledby="tp-feedback-form-title"
      aria-describedby="tp-feedback-form-description"
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: { xs: "95vw", md: "900px" },
          maxHeight: "92vh",
          backgroundColor: COLORS.background,
          borderRadius: "16px",
          boxShadow: "0 24px 64px rgba(0,0,0,0.18)",
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
        }}
      >
        {/* ── Modal Header ── */}
        <Box
          sx={{
            px: "24px",
            py: "18px",
            background: COLORS.primary,
            borderBottom: COLORS.border,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            flexShrink: 0,
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: "12px" }}>
            <Box
              sx={{
                width: 36,
                height: 36,
                borderRadius: "8px",
                background: "#FEF3C7",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <EmojiObjectsOutlinedIcon sx={{ fontSize: 20, color: "#D97706" }} />
            </Box>
            <Box>
              <Typography
                id="tp-feedback-form-title"
                sx={{
                  fontFamily: "Poppins",
                  fontSize: "16px",
                  fontWeight: 600,
                  color: COLORS.text,
                }}
              >
                TP Interview Feedback Form
              </Typography>
              <Typography
                sx={{
                  fontFamily: "Poppins",
                  fontSize: "12px",
                  color: COLORS.text,
                  opacity: 0.5,
                  mt: "2px",
                }}
              >
                Provide detailed feedback to help evaluate the candidate
              </Typography>
            </Box>
          </Box>
          <IconButton
            onClick={onClose}
            disabled={isSubmitting}
            sx={{
              color: COLORS.text,
              p: "6px",
              border: COLORS.border,
              borderRadius: "6px",
              background: COLORS.background,
              "&:hover": { background: COLORS.button_edit_bg },
            }}
          >
            <CloseIcon sx={{ fontSize: 20 }} />
          </IconButton>
        </Box>

        {/* ── Form Content ── */}
        <Box
          component="form"
          onSubmit={handleFormSubmit}
          sx={{
            overflowY: "auto",
            flex: 1,
            px: "24px",
            py: "20px",
            background: COLORS.background,
          }}
        >
          {/* ── Detailed Feedback Section ── */}
          <Box sx={cardSx}>
            <Box sx={{ p: "18px" }}>
              <Box sx={sectionHeaderSx}>
                <Box
                  sx={{
                    width: 4,
                    height: 4,
                    borderRadius: "50%",
                    background: "#8B5CF6",
                  }}
                />
                Detailed Feedback
              </Box>

              <Box sx={{ display: "flex", flexDirection: "column", gap: "14px" }}>
                {[
                  {
                    key: "technicalKnowledge",
                    label: "Technical Knowledge",
                    placeholder: "Describe candidate's technical depth, problem-solving approach...",
                  },
                  {
                    key: "handsOnSkills",
                    label: "Hands-on Skills",
                    placeholder: "Practical experience, coding ability, relevant tools...",
                  },
                  {
                    key: "analyticalThinking",
                    label: "Problem Solving & Logic",
                    placeholder: "Logical reasoning, approach to complex problems...",
                  },
                  {
                    key: "communicationSkills",
                    label: "Communication & Soft Skills",
                    placeholder: "Clarity, articulation, teamwork, presentation skills...",
                  },
                  {
                    key: "culturalFit",
                    label: "Attitude & Cultural Fit",
                    placeholder: "Values alignment, work ethic, team dynamics...",
                  },
                ].map((item) => (
                  <Box key={item.key}>
                    <Typography
                      sx={{
                        fontFamily: "Poppins",
                        fontSize: "12px",
                        fontWeight: 500,
                        color: COLORS.text,
                        mb: "6px",
                        opacity: 0.7,
                      }}
                    >
                      {item.label}
                    </Typography>
                    <TextField
                      fullWidth
                      name={`${item.key}.notes`}
                      placeholder={item.placeholder}
                      multiline
                      rows={2}
                      value={formData[item.key].notes}
                      onChange={handleInputChange}
                      sx={textFieldSx}
                    />
                  </Box>
                ))}

                {/* Additional Observations */}
                <Box>
                  <Typography
                    sx={{
                      fontFamily: "Poppins",
                      fontSize: "12px",
                      fontWeight: 500,
                      color: COLORS.text,
                      mb: "6px",
                      opacity: 0.7,
                    }}
                  >
                    Additional Observations
                  </Typography>
                  <TextField
                    fullWidth
                    name="additionalObservations"
                    placeholder="Any other notable observations or concerns..."
                    multiline
                    rows={2}
                    value={formData.additionalObservations}
                    onChange={handleInputChange}
                    sx={textFieldSx}
                  />
                </Box>
              </Box>
            </Box>
          </Box>

          {/* ── Scorecard Section ── */}
          <Box sx={cardSx}>
            <Box sx={{ p: "18px" }}>
              <Box sx={sectionHeaderSx}>
                <Box
                  sx={{
                    width: 4,
                    height: 4,
                    borderRadius: "50%",
                    background: "#F59E0B",
                  }}
                />
                Scorecard
              </Box>
              <Typography
                sx={{
                  fontFamily: "Poppins",
                  fontSize: "12px",
                  color: COLORS.text,
                  opacity: 0.6,
                  mb: "14px",
                }}
              >
                Rate each area from 1 (Poor) to 5 (Excellent)
              </Typography>

              <TableContainer component={Paper} sx={{ boxShadow: "none" }}>
                <Table size="small">
                  <TableHead>
                    <TableRow sx={{ background: COLORS.background }}>
                      {["Category", "Score", "Comments"].map((col, i) => (
                        <TableCell
                          key={col}
                          align={i === 1 ? "center" : "left"}
                          sx={{
                            fontFamily: "Poppins",
                            fontSize: "11px",
                            fontWeight: 600,
                            color: COLORS.text,
                            opacity: 0.6,
                            textTransform: "uppercase",
                            letterSpacing: "0.05em",
                            borderBottom: COLORS.border,
                            py: "10px",
                          }}
                        >
                          {col}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {[
                      { label: "Technical Knowledge", key: "technicalKnowledge" },
                      { label: "Hands-on Skills", key: "handsOnSkills" },
                      { label: "Problem Solving & Logic", key: "analyticalThinking" },
                      { label: "Communication Skills", key: "communicationSkills" },
                      { label: "Attitude & Cultural Fit", key: "culturalFit" },
                    ].map((row) => (
                      <TableRow
                        key={row.key}
                        sx={{
                          background: COLORS.primary,
                          borderBottom: COLORS.border,
                          "&:hover": { background: COLORS.button_edit_bg },
                        }}
                      >
                        <TableCell
                          sx={{
                            fontFamily: "Poppins",
                            fontSize: "13px",
                            color: COLORS.text,
                            py: "12px",
                            px: "14px",
                            fontWeight: 500,
                            borderBottom: "none",
                          }}
                        >
                          {row.label}
                        </TableCell>
                        <TableCell align="center" sx={{ py: "12px", px: "8px", borderBottom: "none" }}>
                          <TextField
                            type="number"
                            inputProps={{ min: 1, max: 5 }}
                            name={`${row.key}.score`}
                            value={formData[row.key].score}
                            onChange={handleInputChange}
                            size="small"
                            sx={{
                              width: "70px",
                              "& .MuiOutlinedInput-root": {
                                fontFamily: "Poppins",
                                fontSize: "13px",
                                height: "36px",
                                color: COLORS.text,
                                "& fieldset": {
                                  borderColor:
                                    COLORS.border?.replace("1px solid ", "") || "#e5e7eb",
                                },
                              },
                            }}
                          />
                        </TableCell>
                        <TableCell sx={{ py: "12px", px: "14px", borderBottom: "none" }}>
                          <TextField
                            fullWidth
                            name={`${row.key}.comments`}
                            placeholder="e.g., Excellent..."
                            value={formData[row.key].comments}
                            onChange={handleInputChange}
                            size="small"
                            sx={{
                              "& .MuiOutlinedInput-root": {
                                fontFamily: "Poppins",
                                fontSize: "12px",
                                height: "36px",
                                color: COLORS.text,
                                "& fieldset": {
                                  borderColor:
                                    COLORS.border?.replace("1px solid ", "") || "#e5e7eb",
                                },
                              },
                            }}
                          />
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
          </Box>

          {/* ── Final Decision Section ── */}
          <Box sx={cardSx}>
            <Box sx={{ p: "18px" }}>
              <Box sx={sectionHeaderSx}>
                <Box
                  sx={{
                    width: 4,
                    height: 4,
                    borderRadius: "50%",
                    background: "#22C55E",
                  }}
                />
                Final Recommendation
              </Box>

              <Box sx={{ display: "flex", flexDirection: "column", gap: "14px" }}>
                {/* Decision */}
                <Box>
                  <Typography
                    sx={{
                      fontFamily: "Poppins",
                      fontSize: "12px",
                      fontWeight: 500,
                      color: COLORS.text,
                      mb: "6px",
                      opacity: 0.7,
                    }}
                  >
                    Decision
                  </Typography>
                  <FormControl fullWidth size="small">
                    <Select
                      name="decision"
                      value={formData.decision}
                      onChange={handleInputChange}
                      displayEmpty
                      sx={{
                        fontFamily: "Poppins",
                        fontSize: "13px",
                        color: COLORS.text,
                        background: COLORS.primary,
                        border: COLORS.border,
                        borderRadius: "8px",
                        "& .MuiSelect-icon": { color: COLORS.text },
                        "& .MuiOutlinedInput-notchedOutline": { border: "none" },
                        "&:hover": { background: COLORS.button_edit_bg },
                      }}
                    >
                      <MenuItem value="" sx={{ color: COLORS.text }}>
                        Select a decision
                      </MenuItem>
                      {["Strong Hire", "Hire", "Borderline", "No Hire", "Keep in Pipeline"].map(
                        (opt) => (
                          <MenuItem
                            key={opt}
                            value={opt}
                            sx={{ color: COLORS.text, fontFamily: "Poppins" }}
                          >
                            {opt}
                          </MenuItem>
                        )
                      )}
                    </Select>
                  </FormControl>
                </Box>

                {/* Next Round Recommendation */}
                <Box>
                  <Typography
                    sx={{
                      fontFamily: "Poppins",
                      fontSize: "12px",
                      fontWeight: 500,
                      color: COLORS.text,
                      mb: "6px",
                      opacity: 0.7,
                    }}
                  >
                    Next Round Recommendation
                  </Typography>
                  <TextField
                    fullWidth
                    name="nextRoundRecommendation"
                    placeholder="e.g., Proceed to technical round, Recommend for senior position..."
                    value={formData.nextRoundRecommendation}
                    onChange={handleInputChange}
                    size="small"
                    sx={textFieldSx}
                  />
                </Box>

                {/* Remarks for HR */}
                <Box>
                  <Typography
                    sx={{
                      fontFamily: "Poppins",
                      fontSize: "12px",
                      fontWeight: 500,
                      color: COLORS.text,
                      mb: "6px",
                      opacity: 0.7,
                    }}
                  >
                    Remarks for HR / Next Interviewer
                  </Typography>
                  <TextField
                    fullWidth
                    name="remarksForHR"
                    placeholder="Additional context or specific points to discuss..."
                    multiline
                    rows={3}
                    value={formData.remarksForHR}
                    onChange={handleInputChange}
                    sx={textFieldSx}
                  />
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>

        {isSubmitting && <Loader />}

        {/* ── Modal Footer ── */}
        <Box
          sx={{
            px: "24px",
            py: "14px",
            borderTop: COLORS.border,
            background: COLORS.primary,
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end",
            gap: "10px",
            flexShrink: 0,
          }}
        >
          <Button
            onClick={clearForm}
            disabled={isSubmitting}
            startIcon={<ClearIcon sx={{ fontSize: 18 }} />}
            sx={{
              fontFamily: "Poppins",
              fontSize: "13px",
              textTransform: "none",
              color: COLORS.text,
              border: COLORS.border,
              borderRadius: "8px",
              px: "16px",
              py: "6px",
              background: COLORS.background,
              "&:hover": { background: COLORS.button_edit_bg },
            }}
          >
            Clear
          </Button>
          <Button
            type="submit"
            onClick={handleFormSubmit}
            disabled={isSubmitting}
            endIcon={<SendIcon sx={{ fontSize: 18 }} />}
            sx={{
              fontFamily: "Poppins",
              fontSize: "13px",
              textTransform: "none",
              color: "#fff",
              borderRadius: "8px",
              px: "18px",
              py: "6px",
              background: "#8B5CF6",
              border: "1px solid #8B5CF6",
              "&:hover": { background: "#7C3AED" },
              "&:disabled": { opacity: 0.6 },
            }}
          >
            Submit Feedback
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default TP_FeedbackForm;